import { render, staticRenderFns } from "./PriorityDropdown.vue?vue&type=template&id=43cf4b44&scoped=true&"
import script from "./PriorityDropdown.vue?vue&type=script&lang=js&"
export * from "./PriorityDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cf4b44",
  null
  
)

export default component.exports